var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmarkAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 12.5C13.6641 12.5 14 12.1641 14 11.75V0.75C14 0.335938 13.6641 0 13.25 0H2.5C1.12159 0 0 1.12109 0 2.5V13.5C0 14.8789 1.12159 16 2.5 16H13.25C13.6641 16 14 15.6641 14 15.25C14 14.8359 13.6641 14.5 13.25 14.5H13V12.5H13.25ZM11.5 14.5H2.5C1.94872 14.5 1.5 14.0518 1.5 13.5C1.5 12.9482 1.94872 12.5 2.5 12.5H11.5V14.5ZM12.5 11H2.5C2.14453 11 1.80616 11.0742 1.5 11.209V2.5C1.5 1.94825 1.94872 1.5 2.5 1.5H6V6.49909C6 6.91828 6.485 7.15144 6.81238 6.88947L8.5 5.50006L10.1876 6.88947C10.515 7.15144 11 6.91828 11 6.49909V1.5H12.5V11Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAlt);
export default __webpack_public_path__ + "static/media/bookmark-alt.23842829.svg";
export { ForwardRef as ReactComponent };